import moment from 'moment'
import CryptoJS from 'crypto-js'

export const formatDateForSend = (dateTime: string): string =>
  moment(`${dateTime}:00`, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm')

export const stringToHex = (formId: number): string => {
  let hex = ''
  const hexDigits = '0123456789ABCDEF'

  while (formId > 0) {
    const remainder = formId % 16
    hex = hexDigits[remainder] + hex
    formId = Math.floor(formId / 16)
  }

  return hex
}
